import { render, staticRenderFns } from "./meBreed.vue?vue&type=template&id=1ba88452&scoped=true&"
import script from "./meBreed.vue?vue&type=script&lang=js&"
export * from "./meBreed.vue?vue&type=script&lang=js&"
import style0 from "./meBreed.vue?vue&type=style&index=0&id=1ba88452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba88452",
  null
  
)

export default component.exports